import { Network } from '@root/entities/network'
import { WalletAddress } from '@root/entities/wallet'

import * as UserTradingAnalyticsAnalysis from './user-trading-analytics-analysis'
import * as UserTradingAnalyticsDaily from './user-trading-analytics-daily'
import * as UserTradingAnalyticsMcDistribution from './user-trading-analytics-mc-distribution'
import * as UserTradingAnalyticsPerformance from './user-trading-analytics-performance'
import * as UserTradingAnalyticsPhishing from './user-trading-analytics-phishing'

import type { UserTradingAnalyticsDto } from '@root/shared/api/TradeApi'

export interface UserTradingAnalytics {
  walletAddresses: ReadonlyArray<WalletAddress>
  network: Network.Network
  phishing: UserTradingAnalyticsPhishing.UserTradingAnalyticsPhishing
  mcDistribution: UserTradingAnalyticsMcDistribution.UserTradingAnalyticsMcDistribution
  performance: UserTradingAnalyticsPerformance.UserTradingAnalyticsPerformance
  analysis: UserTradingAnalyticsAnalysis.UserTradingAnalyticsAnalysis
  daily: UserTradingAnalyticsDaily.UserTradingAnalyticsDaily
}

export const fromDto = (dto: UserTradingAnalyticsDto): UserTradingAnalytics => {
  return {
    walletAddresses: dto.walletAddresses.map((x) => WalletAddress(x)),
    network: Network.fromDto(dto.network),
    analysis: UserTradingAnalyticsAnalysis.fromDto(dto.analysis),
    phishing: UserTradingAnalyticsPhishing.fromDto(dto.phishing),
    mcDistribution: UserTradingAnalyticsMcDistribution.fromDto(
      dto.mcDistribution,
    ),
    performance: UserTradingAnalyticsPerformance.fromDto(dto.performance),
    daily: UserTradingAnalyticsDaily.fromDto(dto.daily),
  }
}
